import React from "react";
import FormControl from "@material-ui/core/FormControl";
import { MuiPickersUtilsProvider, KeyboardTimePicker } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import TimerIcon from "../../assets/svg/Timer.svg";
import timePickerStyles from "./TimePickerStyles";
import PropTypes from "prop-types";

const TimePicker = (props) => {
  const { fieldLabel, className, value, handleChange, showTimeIcon = true, timerProps = "", disabled = false } = props;
  const classes = timePickerStyles();

  const handleTimeChange = (time) => {
    let processedTime = null;
    if (time instanceof Date && !isNaN(time.getTime())) { // Check for valid Date object
      // If it's a valid date, set seconds to 0,0
      processedTime = new Date(time.setSeconds(0, 0));
    }
    handleChange(processedTime);
  };

  return (
    <>
      {fieldLabel && <div className={classes.fieldLabel}>{fieldLabel}</div>}
      <FormControl variant="filled" className={`${classes.dropdown} ${className}`}>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <KeyboardTimePicker
            {...props}
            ampm={false}
            className={`${classes.timePicker} ${!showTimeIcon ? classes.hideTimeIcon : ""} ${disabled ? classes.timePickerDisabled : ""}`}
            InputProps={{ className: `${classes.timePickerInput} ${timerProps}`, }}
            InputLabelProps={{ className: classes.timePickerLabelProps, }}
            placeholder="HH:MM"
            value={value ?? null}
            keyboardIcon={showTimeIcon ? <img className={classes.timerIcon} src={TimerIcon} alt="timer" /> : null}
            onChange={handleTimeChange}
          />
        </MuiPickersUtilsProvider>
      </FormControl>
    </>
  );
};

TimePicker.propTypes = {
  fieldLabel: PropTypes.string,
  className: PropTypes.string,
  value: PropTypes.any,
  handleChange: PropTypes.func.isRequired,
  showTimeIcon: PropTypes.bool,
  timerProps: PropTypes.string,
  disabled: PropTypes.bool,
  name: PropTypes.string,
  style: PropTypes.any,
};

export default React.memo(TimePicker);
